import { BriefingChartDisplayElementApiModel } from '../../../api/briefings/model/briefing-chart-display-element-api.model';

export class BriefingChartModel {
    chartUrl: string;
    oldChartUrl: string;
    generateOnSend: boolean = false;
    oldWidthPx: number;
    widthPx: number;
    widthPercent: number;
    oldHeightPx: number;
    heightPx: number;
    doBorder: boolean;
    refreshed: boolean = false;

    constructor(
        apiModel?: BriefingChartDisplayElementApiModel
    ) {
        if (apiModel) {
            this.chartUrl = apiModel.chartUrl;
            this.oldChartUrl = apiModel.chartUrl;
            this.generateOnSend = apiModel.generateOnSend || false;
            const styles = JSON.parse(JSON.stringify(apiModel));
            this.widthPx = apiModel.imageProperties.width || 640;
            this.oldWidthPx = this.widthPx;
            this.heightPx = apiModel.imageProperties.displaySize || 250;
            this.oldHeightPx = this.heightPx;
            this.doBorder = styles.doBorder;
        } else {
            this.widthPercent = 100;
            this.heightPx = 250;
        }
    }

    /**
     * Doesn't evaluate chartUrl
     */
    isEqual(other: BriefingChartModel): boolean {

        if (this.generateOnSend !== other.generateOnSend) {
            return false;
        }

        if (this.widthPercent !== other.widthPercent && !(isNaN(this.widthPercent) && isNaN(other.widthPercent))) {
            return false;
        }

        if (this.heightPx !== other.heightPx) {
            return false;
        }

        if (this.doBorder !== other.doBorder) {
            return false;
        }

        if (this.refreshed !== other.refreshed) {
            return false;
        }

        return true;
    }
}
